import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { UpdateTagLayoutMutation, UpdateTagLayoutMutationVariables } from 'types/graphql';
import { UPDATE_TAG_LAYOUT, UPDATE_TAG_LAYOUT_FROM_EDITOR } from '../tagLayouts.api';
import type { TagLayoutSurface } from './useCreateTagLayout';

const UPDATE_BY_SURFACE = { list: UPDATE_TAG_LAYOUT, editor: UPDATE_TAG_LAYOUT_FROM_EDITOR } as const;

/** `updateTagLayout` (P7-R2): `update({ id, input })` over the surface's unchanged document. */
export function useUpdateTagLayout(
  surface: TagLayoutSurface,
  options?: MutationHookOptions<UpdateTagLayoutMutation, UpdateTagLayoutMutationVariables>
) {
  const [mutate, { loading, error }] = useMutation<UpdateTagLayoutMutation, UpdateTagLayoutMutationVariables>(
    UPDATE_BY_SURFACE[surface],
    options
  );
  const update = useCallback(
    ({ id, input }: UpdateTagLayoutMutationVariables) => mutate({ variables: { id, input } }),
    [mutate]
  );
  return { update, loading, error };
}
